import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const WorkOrder = lazy(() =>
    import('@/v1/management/views/WorkOrder').then((module) => ({
        default: module.WorkOrder,
    }))
);

const WorkOrderOperator = lazy(() =>
    import('@/v1/report/views/WorkOrderOperator').then((module) => ({
        default: module.WorkOrderOperator,
    }))
);
const WorkOrderTime = lazy(() =>
    import('@/v1/report/views/WorkOrderTime').then((module) => ({
        default: module.WorkOrderTime,
    }))
);
const WorkOrderServiceLevelAgreement = lazy(() =>
    import('@/v1/report/views/WorkOrderServiceLevelAgreement').then(
        (module) => ({
            default: module.WorkOrderServiceLevelAgreement,
        })
    )
);

export const eventReportRoutes: RouteObject[] = [
    {
        path: `work_order/:mode?`,
        ...PageElement(<WorkOrder />),
    },
    {
        path: `work_order_time`,
        ...PageElement(<WorkOrderTime />),
    },
    {
        path: `work_order_op`,
        ...PageElement(<WorkOrderOperator />),
    },
    {
        path: `work_order_sla`,
        ...PageElement(<WorkOrderServiceLevelAgreement />),
    },
];
